import { TypedDocumentNode, gql } from '@apollo/client';

import { useTypedParams } from '@sorare/routing';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { Transactions } from '@sorare/marketplace/src/components/player/Transactions';

import {
  baseballPlayerTransactionsQuery,
  baseballPlayerTransactionsQueryVariables,
} from './__generated__/page.graphql';
import { PageParams } from './__generated__/routeParams';

const BASEBALL_PLAYER_TRANSACTIONS_QUERY = gql`
  query baseballPlayerTransactionsQuery($slug: String!) {
    anyPlayer(slug: $slug) {
      slug
      ...Transactions_anyPlayerInterface
    }
  }
  ${Transactions.fragments.anyPlayer}
` as TypedDocumentNode<
  baseballPlayerTransactionsQuery,
  baseballPlayerTransactionsQueryVariables
>;

const PlayerCards = () => {
  const { slug } = useTypedParams<PageParams>();
  const { data, loading } = useQuery(BASEBALL_PLAYER_TRANSACTIONS_QUERY, {
    variables: {
      slug,
    },
  });

  const baseballPlayer = data?.anyPlayer;
  if (loading) return <LoadingIndicator fullHeight />;
  if (!slug || !baseballPlayer) return null;
  return <Transactions anyPlayer={baseballPlayer} />;
};

export default PlayerCards;
